(ns frontend.ui.component.file-input.view
  "This file contains two UI components:
  - `file-input`: component to upload files by selecting them from the browser
    dialog box or by drag and drop
  - `file-upload-status`: component to display the status of the upload of one
    file"
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.ui.component.file-input.style :as style]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.icon.view :refer [icon]]
   [frontend.utils :as fu]
   [herb.core :refer [<class]]))

(defn file-upload-status
  [{:keys [handle-remove-file]} {:keys [filename percents status message] :as upload-state}]
  [:div
   {:class (<class style/file-status)}
   [grid/row {}
    [grid/column
     {:span 6}
     [:div
      {:class (<class style/file-name)}
      [:div
       {:class (<class style/file-name-icon)}
       [icon :paperclip]]
      filename]]
    [grid/column {:span 2}
     [:div
      {:class (<class style/file-name)}
      (loc/tr status)]]
    [grid/column {:span 3}
     [:div
      {:class (<class style/progress-bar-container)}
      ;; Label over the track, not inside the fill.
      [:div
       {:class (<class style/progress-bar percents)}]
      [:span
       {:class (<class style/progress-bar-description)}
       (some-> message
               name
               string/capitalize)]]]
    [grid/column {:span 1}
     [:a
      {:href     "#"
       :class    (<class style/file-remove)
       :on-click #(handle-remove-file upload-state)}
      [icon :trash-alt]]]]])

(defn accepted-file?
  "Whether file metadata matches an HTML accept rule in `file-types`.

  Supports filename extensions, exact MIME types, and MIME wildcards. An empty
  file-type collection accepts every file."
  [file-types {:keys [name type]}]
  (let [accepted-types (->> file-types
                            (map string/trim)
                            (remove string/blank?)
                            (map string/lower-case))
        file-name (some-> name string/lower-case)
        content-type (some-> type string/lower-case)]
    (or (empty? accepted-types)
        (boolean
         (some (fn [accepted-type]
                 (cond
                   (string/starts-with? accepted-type ".")
                   (and file-name
                        (string/ends-with? file-name accepted-type))

                   (string/ends-with? accepted-type "/*")
                   (and content-type
                        (string/starts-with? content-type
                                             (subs accepted-type 0 (dec (count accepted-type)))))

                   :else
                   (= content-type accepted-type)))
               accepted-types)))))

(defn- add-accepted-files!
  [{:keys [file-types files handle-add-file]}]
  (doseq [file files
          :when (accepted-file? file-types
                                {:name (.-name file)
                                 :type (.-type file)})]
    (handle-add-file file)))

(defn file-input
  "See `file-input/core` for dispatch/subscribe functions"
  [{:keys [input-id file-types handle-add-file dropzone-content images-only? multiple?]}]
  [:div
   {:on-drag-over fu/prevent-default-event!
    :on-change    (fn [e]
                    (fu/prevent-default-event! e)
                    (fu/stop-propagation-event! e)
                    (add-accepted-files! {:file-types      file-types
                                          :files           (.. e -target -files)
                                          :handle-add-file handle-add-file}))
    :on-drop      (fn [e]
                    (fu/prevent-default-event! e)
                    (fu/stop-propagation-event! e)
                    (add-accepted-files! {:file-types      file-types
                                          :files           (.. e -dataTransfer -files)
                                          :handle-add-file handle-add-file}))}
   (if dropzone-content
     [:label
      {:for input-id}
      dropzone-content]
     [:label
      {:for   input-id
       :class (<class style/file-input)}
      [:div
       {:class (<class style/file-input-icon)}
       [icon :cloud-upload]]
      (if images-only?
        (loc/tr :drop-images-to-upload-or-browse)
        (loc/tr :drop-files-to-upload-or-browse))])
   [:input
    (merge {:id    input-id
            :type  "file"
            :class (<class style/input)}
           (when multiple?
             {:multiple true})
           (when file-types
             {:accept (string/join "," file-types)}))]])
